import React from "react";
import { Grid, Paper } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

// Contexts

// Components
import Form_01 from "./Form_01";
// import Form_02 from "./Form_02";
import Form_03 from "./Form_03";
import Form_04 from "./Form_04";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginBottom: "1rem",
    marginLeft: "8px",
  },
  paperBox: {
    padding: "0.5rem",
  },
}));

const DashboardForm = () => {
  const classes = useStyles();

  return (
    <Paper className={classes.paper}>
      <Grid
        container
        className={classes.paperBox}
        justifyContent="space-between"
        alignItems="flex-start"
      >
        <Form_01 /> {/* <Form_02 /> */} <Form_03 />
        <Form_04 />
      </Grid>{" "}
    </Paper>
  );
};

export default DashboardForm;
